export default {
    ru: {
        'Success': 'Выполнено',
        'The data has been copied!': 'Данные успешно скопированы в буфер обмена!',
        'Copy': 'Скопировать',
        'Generate new API key': 'Сгенерировать новый API ключ',
        'API Keys': 'API ключи',
        'Your API Key': 'Ваш API ключ',
        'This is the only time it will be shown so don\'t lose it!': 'Это единственный раз, когда он будет показан, так что не теряйте его!',
        'Close': 'Закрыть',
        'Delete': 'Удалить',
        'Name': 'Имя',
        'Created At': 'Создано',
        'Expired At': 'Активен до',
        'You can\'t create more than 5 keys': 'Вы не можете создавать более 5 ключей',
        'You have not created any personal access tokens.': 'У вас отсутствуют API ключи',
        'Your API key': 'Ваш API ключ'
    }
}
